;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('ColorService', ColorService)

  ColorService.$inject = ['$uibModal']

  /**
   * Constructor
   */
  function ColorService ($uibModal) {
    var self = this

    var colors = [
      {
        name: 'Rouge',
        value: '#F44336'
      },
      {
        name: 'Rouge',
        value: '#E91E63'
      },
      {
        name: 'Violet',
        value: '#9C27B0'
      },
      {
        name: 'Violet Profond', // Deep Purple ?
        value: '#673AB7'
      },
      {
        name: 'Indigo',
        value: '#3F51B5'
      },
      {
        name: 'Bleu',
        value: '#2196F3'
      },
      {
        name: 'Bleu clair', // 'Light blue ?
        value: '#03A9F4'
      },
      {
        name: 'Cyan',
        value: '#00BCD4'
      },
      {
        name: 'Teal', // TODO
        value: '#009688'
      },
      {
        name: 'Vert',
        value: '#4CAF50'
      },
      {
        name: 'Vert clair', // Light Green ?
        value: '#8BC34A'
      },
      {
        name: 'Citron',
        value: '#CDDC39'
      },
      {
        name: 'Jaune',
        value: '#CDDC39'
      },
      {
        name: 'Ambre',
        value: '#FFC107'
      },
      {
        name: 'Orange',
        value: '#FF9800'
      },
      {
        name: 'Orange Profond', // Deep Orange
        value: '#FF5722'
      },
      {
        name: 'Marron',
        value: '#795548'
      },
      {
        name: 'Gris',
        value: '#9E9E9E'
      },
      {
        name: 'Bleu Gris',
        value: '#607D8B'
      },
      {
        name: 'Noir',
        value: '#000000'
      },
      {
        name: 'Blanc',
        value: '#FFFFFF'
      }
    ]

    //
    _.extend(self, {
      // Public Attributes
      colors: colors,

      // Public Methods
      getLuminance: getLuminance,
      getColorName: getColorName,
      pickColor: pickColor
    })

    /**
     * return the luminance of a color : > 200 is black
     * @param c Color
     * @returns {number}
     */
    function getLuminance (c) {
      c = c || '#ffffff'
      var color = c.substring(1) // strip #
      var rgb = parseInt(color, 16) // convert rrggbb to decimal
      var r = (rgb >> 16) & 0xff // extract red
      var g = (rgb >> 8) & 0xff // extract green
      var b = (rgb >> 0) & 0xff // extract blue

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709

      // luma > 200 : black
      return luma
    }

    /**
     * Format a color
     * @param id
     * @returns {string}
     */
    function getColorName (id) {
      if (!id) {
        return '#0F0F0F'
      }
      return '#' + intToARGB(hashCode(id))
    }

    /**
     * Return the hashcode of a string
     * @param str
     * @returns {number}
     */
    function hashCode (str) {
      var hash = 0
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      return hash
    }

    /**
     *
     * @param i
     * @returns {string}
     */
    function intToARGB (i) {
      return (((i >> 24) & 0xFF).toString(16) +
      ((i >> 16) & 0xFF).toString(16) +
      ((i >> 8) & 0xFF).toString(16) +
      (i & 0xFF).toString(16)).slice(0, 6)
    }

    function pickColor (color) {
      return $uibModal.open({
        size: 'md',
        resolve: {
          colors: [function () {
            return self.colors
          }],
          selected: [function () {
            return angular.copy(color)
          }]
        },
        templateUrl: '/app/common/services/color/color-picker.html',
        controllerAs: 'ctrl',
        controller: ['colors', 'selected', function (colors, selected) {
          var self = this
          self.colors = colors
          self.selected = selected

          self.select = function (color) {
            self.selected = color.value
          }

        }]
      }).result
    }
  }
})(window.angular, window._)
